import vue from 'vue'
// import NP from 'number-precision'
import AddOrder from '../components/orderAdd.vue'
import DeleteOrder from '../components/orderDelete.vue'
import DeleteOrderAll from '../components/orderDeleteAll.vue'
import { isNull, isNumber } from '../../assets/js/validators'
import store from '../../store/index'
import ViewModel from '../components/viewPage.vue'
import Bus from '../../assets/js/eventBus'
// import orderViewUser from '../components/orderViewUser.vue'
// import orderViewClient from '../components/orderViewClient.vue'
import orderStatus from './../components/orderStatus.vue'
import statusSwitch from './../components/statusSwitch.vue'
import statusSelected from './../components/statusSelect.vue'
import modelSearch from './../components/modelSearch.vue'
// import {
//   tkDate
// } from '@moke/vue-tk'
// import { indexOf } from 'lodash'
// import financeVerify from './../components/financeVerify.vue'

const that = vue.prototype
export default {
  className: 'Order',
  mixin: {
    selection: true,
    actionWidth: 120,
    fields: [
      { // 销售信息
        name: 'userid',
        note: '销售人员',
        width: 80,
        // view: {
        //   component: orderViewUser
        // }
      },
      // 用户所属公司
      {
        name: 'userCompany',
        width: 80,
        note: '所属公司',
        validators: [
          val => (val) ? null : '所属公司不可为空'
        ]
      },
      { // 型号
        name: 'finishProductid',
        listWhere: (where) => {
          where.isBatching = { $ne: true }
          where.formula = { $exists: true }
        },
        width: 80,
        validators: [
          isNull
        ]
      },
      {
        // 车间型号
        name: 'modelId',
        note: '车间大类',
        width: 80,
        disabled: true,
        render: (record) => {
          return `${record.finishProductid.model.name}`
        },
        // hidden: () => true,
        search: {
          component: modelSearch
        },
      },
      { // 售价
        name: 'sellingPrice',
        width: 80,
        // disabled: true,
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
        validators: [
          isNull, isNumber
        ]
      },
      { // 成本
        name: 'costPrice',
        width: 80,
        hidden: () => store.state.user && store.state.user.correlatedUser && store.state.user.correlatedUser.length,
        disabled: true,
        validators: [
          isNull, isNumber
        ],
        render: (record) => {
          // if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') !== -1 && store.state.user.correlatedBy.length === 0) { return `` } else if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') === -1) { return `` } else { return `${record.costPrice}` }
          if (store.state.user && Object.keys(store.state.user).indexOf('correlatedUser') !== -1 && store.state.user.correlatedUser.length) { return `` } else { return `${record.costPrice}` }
        },
      },
      { // 状态
        name: 'status',
        width: 100,
        validators: [
          isNull
        ],
        view: {
          component: orderStatus
        },
        search: {
          component: statusSelected
        },
      },
      {// 包装
        name: 'packid',
        note: '包装',
        width: 80,
        validators: [
          (val) => val ? null : '包装不可为空'
        ]
      },
      {// 托盘
        name: 'palletid',
        width: 80,
        validators: [
          (val) => val ? null : '托盘不可为空'
        ]
      },
      { // 吨数
        name: 'amount',
        // hidden: () => true,
        width: 80,
        validators: [
          isNull, isNumber
        ]
      },
      // 每吨运费
      {
        name: 'pricePerTon',
        note: '每吨运费',
        width: 100,
        validators: [
          isNull, isNumber
        ],
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
      },
      {// 麦头
        name: 'markid',
        width: 80,
      },
      {
        name: 'taxRate',
        width: 80,
        validators: [
          (val) => val ? null : '税率不可为空'
        ],
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
      },
      { // 客户
        name: 'clientid',
        width: 110,
        // view: {
        //   component: orderViewClient
        // },
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
        listWhere: (where) => {
          // if (store.state.user.adminRole === 'sale') {
          // where.userid = store.state.user.objectId
          // }
          if (store.state.user && store.state.user.allClient === 'Yes') { } else {
            where.userid = store.state.user.objectId
          }
        },
        validators: [
          isNull
        ],
      },
      { // 利润
        name: 'profit',
        width: 80,
        disabled: true,
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
        validators: [
          (val) => val ? null : '不可为空'
        ],
        // render: (record) => {
        //   if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') !== -1 && store.state.user.correlatedBy.length === 0) { return `` } else if (store.state.user && store.state.user.allClient === 'No' && Object.keys(store.state.user).indexOf('correlatedBy') === -1) { return `` } else { return `${record.profit}` }
        // },
      },
      { // 运费
        name: 'shipping',
        width: 80,
        disabled: true,
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
        validators: [
          isNull, isNumber
        ]
      },
      { // 交付日期
        name: 'shipDate',
        validators: [
          isNull,
          (val) => new Date(val).getTime() + 24 * 60 * 60 * 1000 - 1 >= new Date().getTime() ? null : '不可选择今日之前的日期'
        ]
      },
      // { // 提成
      //   name: 'commission',
      //   // hidden: () => store.state.user && store.state.user.adminRole === 'workshop',
      //   validators: [
      //     isNull, isNumber
      //   ]
      // },
      // 客户提成
      {
        name: 'clientCommission',
        width: 80,
        disabled: true,
        hidden: () => store.state.user && store.state.user.allShopManagements === 'No',
        // validators: [
        //   isNull, isNumber
        // ]
      },
      {
        name: 'remarks',
        width: 80,
      },
      {// 下单日期
        name: 'orderDate',
        // hidden: () => true
      },
      // {
      //   name: 'taxRate'
      // },

      // 更新时间
      'updatedAt',
      // 发出时间
    ]
  },
  search: [
    'status',
    'userCompany',
    'modelId',
    'clientid',
    'orderDate',
    'updatedAt',
    'sentAt'
  ],
  hooks: {
    async beforeFetch ({ where }) {
      if (where.status === 'null') {
        delete where.status
      }
      where.isReserve = { $ne: true }
      // if (store.state.user && store.state.user.adminRole === 'sale') {
      //   // 销售经理
      //   where.userid = store.state.user.objectId
      // }
      // if (store.state.user && store.state.user.adminRole === 'admin') {
      //   // 超级管理员
      // }
      // if (store.state.user && store.state.user.adminRole === 'workshop') {
      //   // 车间经理
      // where.shopManagementid = {
      //   $in: store.state.user.shopManagements
      // }
      // }
      // 查看所有订单
      if (where.modelId) {
        if (where.modelId === 'null') {
          delete where.finishProductid
          delete where.modelId
        } else {
          let res = await that.$modelAjax.getData('finishProduct', {
            params: {
              where: {
                model: where.modelId
              }
            }
          })
          let target = []
          for (let i in res.results) {
            target.push(res.results[i].objectId)
          }
          delete where.modelId
          where.finishProductid = { $in: target }
        }
        console.log(where)
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
        // where.finishProductid = { workShop: { objectId: 'ElRzpWGd5W' } }
        // where = {
        //   'finishProductid.workShop.objectId': 'ElRzpWGd5W'
        // }
        // where.finishProductid = {
        //   'workShop.objectId': 'ElRzpWGd5W'
        // }
        // where['finishProductid.workShop.objectId'] = 'ElRzpWGd5W'
        // where.finishProductid.workShop.objectId = {
        //   $in: store.state.user.shopManagements
        // }
      }
    },
    async beforeSave ({ data, objectId }) {
      // if (objectId) {
      //   let order = await that.$tkParse.getData(`/classes/Order/${objectId}`).catch(e => { })
      //   let myDate = new Date(order.createdAt)
      //   if (data.status !== order.status) {
      //     let user = await that.$tkParse.getData(`/classes/_User/${order.userid}`).catch(e => { }) // 用户
      //     let Client = await that.$tkParse.getData(`/classes/Client/${order.clientid}`).catch(e => { }) // 客户
      //     let finishProduct = await that.$tkParse.getData(`/classes/finishProduct/${order.finishProductid}`).catch(e => { }) // 型号
      //     let Pack = await that.$tkParse.getData(`/classes/Pack/${order.packid}`).catch(e => { }) // 包装
      //     let Pallet = await that.$tkParse.getData(`/classes/Pallet/${order.palletid}`).catch(e => { }) // 托盘
      //     let type = {

      //       add: '新订订单',
      //       read: '已读订单',
      //       finish: '已完成订单',
      //       madeing: '生产中订单',
      //       transit: '运输中订单',
      //       complete: '已生产完成订单',

      //       // sent: '已发出订单',
      //       deliveriesTaked: '已收货订单',
      //       // confirmed: '审完成订单'
      //     }
      //     // TODO 发送短信消息
      //     that.$tkParse.post('/sms/send', {
      //       'phone': user.username,
      //       'templateId': 'HqLgB1',
      //       'vars': {
      //         // 短信模板变量
      //         message: `您于${myDate.getMonth() + 1}月${myDate.getDate()}日下单的${Client.name + finishProduct.name} ${Pack.name + Pallet.name} ${type[data.status]}`
      //       }
      //     })
      //   }
      // }
    },
    afterInsert (data) {
      console.log(data, 'afterInsert')
    },
    async afterUpdate (data) {
      console.log(data, 'afterUpdate')
    }
  },
  action: {
    view: store.state.user && store.state.user.authority.order.view ? {
      type: 'row',
      text: '查看',
      viewTitle: '查看订单',
      component: ViewModel,
    } : false,
    // view: false,
    formula: store.state.user && store.state.user.authority.order.formula
      ? {
        type: 'row',
        text: '查看配方',
        callback: function ({ record }) {
          Bus.$emit('formula', record)
          Bus.$emit('showModal', true)
        }
      } : false,
    create: store.state.user && store.state.user.authority.order.create
      ? {
        type: 'list',
        text: '新建订单',
        buttonType: 'primary', // 按钮的类型
        component: AddOrder
      } : false,
    choiceDel: store.state.user && store.state.user.authority.order.del
      ? {
        type: 'list',
        text: '批量删除',
        buttonType: 'danger', // 按钮的类型
        component: DeleteOrderAll
      }
      : false,
    // edit: store.state.user && store.state.user.authority.order.edit
    //   ? {
    //     type: 'row',
    //     text: '变更状态',
    //     component: 'akModelEditor',
    //     fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
    //       userid: false,
    //       userCompany: false,
    //       pricePerTon: false,
    //       clientCommission: false,
    //       shopManagementid: false,
    //       sentAt: false,
    //       finishProductid: false,
    //       sellingPrice: false,
    //       amount: false,
    //       packid: false,
    //       palletid: false,
    //       markid: false,
    //       clientid: false,
    //       profit: false,
    //       shipping: false,
    //       shipDate: false,
    //       costPrice: false,
    //       commission: false,
    //       orderDate: false,
    //       status: {
    //         disabled: false
    //       },
    //       remarks: false,
    //       taxRate: false
    //     }
    //   } : false,
    edit: store.state.user && store.state.user.authority.order.edit
      ? {
        type: 'row',
        text: '变更状态',
        title: '变更状态',
        component: statusSwitch,
        hidden ({ record }) {
          let statusArr = ['add', 'read', 'madeing', 'complete']
          if (record && statusArr.indexOf(record.status) === -1) {
            return true
          }
        }
      } : false,
    reserve: store.state.user && store.state.user.authority.order.reserve ? {
      type: 'row',
      text: '备货',
      hidden ({ record }) {
        let statusArr = ['add', 'read', 'madeing', 'complete']
        if (record && statusArr.indexOf(record.status) === -1) {
          return true
        }
      },
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('提示', '确认此订单备货？')
        let rs = null
        try {
          rs = await vm.$modelAjax.put(modelName, record.objectId, {
            isReserve: true
          })
        } catch (e) {
          vm.$notification.error({
            message: '网络错误',
            description: '网络错误'
          })
        }
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '此订单完成备货'
          })
        }
        vm.refresh()
      },
    } : false,
    delete: false,
    myDelete: store.state.user && store.state.user.authority.order.del
      ? {
        type: 'row',
        text: '删除',
        component: DeleteOrder
      }
      : false
    // deleteAll: store.state.user && store.state.user.adminRole === 'admin'
    //   ? {
    //     type: 'list',
    //     text: '删除',
    //     component: DeleteOrder
    //   }
    //   : false
  }
}
